export enum ActionTypes {
  SAVE_LOCATIONS = 'SAVE_LOCATIONS'
}
